import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ThemePalette } from '@angular/material/core';
import { MenuPositionY } from '@angular/material/menu';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { Assessment } from 'src/API';
import { PDFType } from '../dry-eye-pdf-export.component';

export type ButtonAppearance = ButtonAppearances | 'standard' | 'raised' | 'stroked';

export enum ButtonAppearances {
  Standard = 'standard',
  Raised = 'raised',
  Stroked = 'stroked'
}

export type DropdownArrowDirection = DropdownArrowDirections | 'up' | 'down';

export enum DropdownArrowDirections {
  Up = 'up',
  Down = 'down'
}

@Component({
  selector: 'csi-pdf-export-button',
  templateUrl: './pdf-export-button.component.html',
  styleUrls: ['./pdf-export-button.component.css']
})
export class PdfExportButtonComponent implements OnDestroy {
  @Input() appearance: ButtonAppearance = ButtonAppearances.Raised;
  @Input() color: ThemePalette;
  @Input() menuPositionY: MenuPositionY = 'below';
  @Input() dropdownArrowDirection: DropdownArrowDirection = DropdownArrowDirections.Up;
  @Input() disabled = false;
  @Input() assessment: Assessment;

  @Input() assessmentMethod: string;
  @Input() isLocked: boolean;

  @Output() generatePdf = new EventEmitter<{ pdfType: PDFType; lang: string; isLocked: boolean }>();

  public readonly ButtonAppearances = ButtonAppearances;
  public readonly DropdownArrowDirections = DropdownArrowDirections;
  public destroy$: Subject<void> = new Subject<void>();

  public pdfButtonConfigs = [
    { type: 'detailed', lang: 'en', friendlyName: 'Detailed PDF' },
    { type: 'simple', lang: 'en', friendlyName: 'Simple PDF' },
    { type: 'summary', lang: 'en', friendlyName: 'Summary PDF' },
    { type: 'custom', lang: 'en', friendlyName: 'Custom PDF' }
  ];

  constructor(public translocoService: TranslocoService) {}

  public generatePDF(pdfType: PDFType, lang: string = 'en', isLocked = this.isLocked) {
    this.generatePdf.emit({ pdfType, lang, isLocked });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
